// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinic-settings-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 1300px;
    margin: 3rem auto;
    padding: 3rem 2.5rem;
    background-color: var(--clr-grey-2);
    border-radius: 12px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04);
    border: 1px solid var(--clr-grey-3);
  }
  
  .clinic-settings-header {
    text-align: center;
  }
  
  .clinic-settings-heading {
    font-size: 2.2rem;
    font-weight: 700;
    color: var(--clr-grey-9);
    margin-bottom: 0.8rem;
  }
  
  .clinic-settings-description {
    font-size: 1.2rem;
    color: var(--clr-white);
    line-height: 1.6;
    /* max-width: 720px; */
    margin: 0 auto;
  }
  
  .clinic-settings-body {
    width: 100%;
  }

  
  `, "",{"version":3,"sources":["webpack://./src/components/ClinicSettings/ClinicSettings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb","sourcesContent":[".clinic-settings-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    max-width: 1300px;\n    margin: 3rem auto;\n    padding: 3rem 2.5rem;\n    background-color: var(--clr-grey-2);\n    border-radius: 12px;\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04);\n    border: 1px solid var(--clr-grey-3);\n  }\n  \n  .clinic-settings-header {\n    text-align: center;\n  }\n  \n  .clinic-settings-heading {\n    font-size: 2.2rem;\n    font-weight: 700;\n    color: var(--clr-grey-9);\n    margin-bottom: 0.8rem;\n  }\n  \n  .clinic-settings-description {\n    font-size: 1.2rem;\n    color: var(--clr-white);\n    line-height: 1.6;\n    /* max-width: 720px; */\n    margin: 0 auto;\n  }\n  \n  .clinic-settings-body {\n    width: 100%;\n  }\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
